import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44b481c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ignore_com-top" }
const _hoisted_2 = { class: "page-search content-box ptheader" }
const _hoisted_3 = { action: "/" }
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = { class: "top" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最近查找", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"width":"100%","height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_space_metting = _resolveComponent("space-metting")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header-return",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _createVNode(_component_VanIcon, { name: "arrow-left" })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createVNode(_component_van_search, {
          modelValue: _ctx.spaceName,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.spaceName) = $event)),
            _ctx.onSearch
          ],
          onFocus: _ctx.clearHistorySearch,
          onBlur: _ctx.getHistorySearch,
          onClear: _ctx.onCancel,
          placeholder: "输入地点"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur", "onClear"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goMetting && _ctx.goMetting(...args)))
            }, "查看所有会议室")
          ])
        ]),
        (_ctx.searchData &&  _ctx.searchData.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchData, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "space-item",
                onClick: ($event: any) => (_ctx.triggerSearchSpace(item))
              }, [
                _createElementVNode("img", {
                  src: _ctx.parseImgUrl('search-icon','icon_location.svg'),
                  alt: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("p", null, _toDisplayString(item.localName), 1)
              ], 8, _hoisted_7))
            }), 256))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.historySearchData, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "space-item",
                onClick: ($event: any) => (_ctx.triggerSearchSpace(item))
              }, [
                _createElementVNode("img", {
                  src: _ctx.parseImgUrl('search-icon','icon_location.svg'),
                  alt: ""
                }, null, 8, _hoisted_10),
                _createElementVNode("p", null, _toDisplayString(item.localName), 1)
              ], 8, _hoisted_9))
            }), 256))
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showMetting,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showMetting) = $event)),
      teleport: "body",
      class: "buiding-box",
      style: {"width":"100%","height":"100%"},
      position: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_space_metting, { onCloseMetting: _ctx.closeMetting }, null, 8, ["onCloseMetting"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}